/**
 * Sprint-6 E.1: Per-Property Rechnungsbausteine.
 * Backend: src/StayOn.Modules.Properties/Contracts/InvoiceBlockContracts.cs
 */

export type InvoiceBlockKind = 'PerStay' | 'PerNight' | 'PerPersonPerStay' | 'PerPersonPerNight';

export const invoiceBlockKindOptions: ReadonlyArray<{
  value: InvoiceBlockKind;
  label: string;
  /** Inline-Display-Form: liest sich wie ein Satz, z.B. "5,00 € · pro Person und Nacht". */
  inline: string;
}> = [
  { value: 'PerStay', label: 'Pro Aufenthalt', inline: 'pro Aufenthalt' },
  { value: 'PerNight', label: 'Pro Nacht', inline: 'pro Nacht' },
  {
    value: 'PerPersonPerStay',
    label: 'Pro Person und Aufenthalt',
    inline: 'pro Person und Aufenthalt',
  },
  { value: 'PerPersonPerNight', label: 'Pro Person und Nacht', inline: 'pro Person und Nacht' },
];

/**
 * Sprint 7 DE-VAT: Steuer-Kategorie pro Baustein. Steuert welcher Tenant-Satz greift:
 * Accommodation → 7%, Services → 19%, TaxFree → 0%.
 */
export type InvoiceTaxCategory = 'Accommodation' | 'Services' | 'TaxFree';

export const invoiceTaxCategoryOptions: ReadonlyArray<{
  value: InvoiceTaxCategory;
  label: string;
  hint: string;
}> = [
  { value: 'Accommodation', label: 'Übernachtung', hint: 'i.d.R. 7% MwSt' },
  { value: 'Services', label: 'Service / Reinigung', hint: 'i.d.R. 19% MwSt' },
  { value: 'TaxFree', label: 'Steuerfrei', hint: '0% — z.B. Kurtaxe oder Stadttaxe' },
];

export interface InvoiceBlockResponse {
  id: string;
  propertyId: string;
  label: string;
  kind: InvoiceBlockKind;
  taxCategory: InvoiceTaxCategory;
  unitPrice: number;
  currency: string;
  sortOrder: number;
  isActive: boolean;
  notes?: string | null;
  createdAt: string;
  updatedAt?: string | null;
}

export interface CreateInvoiceBlockRequest {
  label: string;
  kind: InvoiceBlockKind;
  taxCategory: InvoiceTaxCategory;
  unitPrice: number;
  currency?: string | null;
  isActive: boolean;
  notes?: string | null;
}

export type UpdateInvoiceBlockRequest = CreateInvoiceBlockRequest;

export interface ReorderInvoiceBlocksRequest {
  orderedIds: string[];
}
